// extracted by mini-css-extract-plugin
export default {"bringgMapRoutePlayer":"bringg-map-route-player-controls_bringgMapRoutePlayer__6wER2","bringgMapRoutePlayerIcon":"bringg-map-route-player-controls_bringgMapRoutePlayerIcon__BYMy9"};